import { render, staticRenderFns } from "./SecurityAddressMortgage.vue?vue&type=template&id=68a5f6ef"
import script from "./SecurityAddressMortgage.vue?vue&type=script&lang=js"
export * from "./SecurityAddressMortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports